import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LinkedFieldSet } from '../Models/linkedFieldSet';
import { Observable } from 'rxjs';
import { SimpleFormFlowField } from '../Models/SimpleFormFlowField';
import { ExistingLinkedFieldSetViewModel } from '../Models/existingLinkedFieldSetViewModel';
import { FormFlowFieldTypes } from '../Constants/FormFlowFieldTypes';

@Injectable({
    providedIn: 'root'
})
export class LinkedFieldsService {

	constructor(private readonly http: HttpClient) {
	}

    private apiFormFlowRootUrl = "/api/formflow";
    private apiLinkedFieldsUrl = "linked-field-sets";

    add(tenantId: string, moduleId: string, version: number, linkedFieldSet: LinkedFieldSet): Observable<LinkedFieldSet> {
	    return this
	        .http
            .post<LinkedFieldSet>(`${this.apiFormFlowRootUrl}/${tenantId}/${moduleId}/${version}/${this.apiLinkedFieldsUrl}/`, linkedFieldSet);
    }

    remove(tenantId: string, moduleId: string, version: number, linkedFieldSetId: string): Observable<any> {
        return this
			.http
            .delete(`${this.apiFormFlowRootUrl}/${tenantId}/${moduleId}/${version}/${this.apiLinkedFieldsUrl}/${linkedFieldSetId}`);
    }

    get(tenantId: string, moduleId: string, version: number): Observable<ExistingLinkedFieldSetViewModel[]> {
        return this.http.get<ExistingLinkedFieldSetViewModel[]>(`${this.apiFormFlowRootUrl}/${tenantId}/${moduleId}/${version}/${this.apiLinkedFieldsUrl}`);
	}

    getFieldsWithNoParentLinkedField(tenantId: string, moduleId: string, version: number, fieldType: FormFlowFieldTypes): Observable<SimpleFormFlowField[]> {
        return this
            .http
            .get<SimpleFormFlowField[]>(`${this.apiFormFlowRootUrl}/${tenantId}/${moduleId}/${version}/${this.apiLinkedFieldsUrl}/fields/no-parent/${fieldType}/`);
    }

    getFieldsAtSameLevelLinkedField(parentField: SimpleFormFlowField, tenantId: string, moduleId: string, version: number, fieldType: FormFlowFieldTypes): Observable<SimpleFormFlowField[]> {
        return this
            .http
            .post<SimpleFormFlowField[]>(`${this.apiFormFlowRootUrl}/${tenantId}/${moduleId}/${version}/${this.apiLinkedFieldsUrl}/fields/same-level/${fieldType}/`, parentField);
    }

    getIsFieldPartOfAnyLinkedFieldSets(tenantId: string, moduleId: string, version: number, fieldId: string): Observable<boolean> {
        return this
            .http
            .get<boolean>(`${this.apiFormFlowRootUrl}/${tenantId}/${moduleId}/${version}/${this.apiLinkedFieldsUrl}/${fieldId}`);
    }
}
